export default (props, vars) => `https://www.loom.com/embed/${props?.['id']}`;
